import { Grid } from "@mui/material";
import FormTextField from "./FormTextField";
import { EMAIL_FORMAT_REGEX } from "./ticketFormConfig";

// Name, phone and email of whoever opens the ticket
const OpenerDetailsFields = ({ formData, fieldErrors, handleNameChange, handlePhoneChange, handleEmailChange }) => {
  const emailFormatInvalid =
    !!formData.email && !EMAIL_FORMAT_REGEX.test(formData.email);
  const emailErrorMessage =
    fieldErrors.email ||
    (emailFormatInvalid ? "שדה אימייל יכול להכיל כתובת מייל תקינה בלבד" : "");

  return (
    <>
      <Grid item xs={12} md={6}>
        <FormTextField
          label="שם פרטי"
          value={formData.firstName}
          onChange={handleNameChange("firstName", "שם פרטי")}
          error={!!fieldErrors.firstName}
          helperText={fieldErrors.firstName}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          label="שם משפחה"
          value={formData.lastName}
          onChange={handleNameChange("lastName", "שם משפחה")}
          error={!!fieldErrors.lastName}
          helperText={fieldErrors.lastName}
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          label="טלפון"
          value={formData.phone}
          onChange={handlePhoneChange}
          inputProps={{ inputMode: "numeric" }}
          error={!!fieldErrors.phone}
          helperText={fieldErrors.phone}
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          label="אימייל"
          value={formData.email}
          onChange={handleEmailChange}
          error={!!emailErrorMessage}
          helperText={emailErrorMessage}
        />
      </Grid>
    </>
  );
};

export default OpenerDetailsFields;
